module.exports = __webpack_public_path__ + "static/media/liveNow.d2ccd91c.svg";